import { useEffect, useState } from "react";

export const useSidebarWidth = (side: "Left" | "Right") => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const observed = new WeakSet<HTMLElement>();
    const selector = `[data-sidebar-side="${side}"]`;

    const updateWidth = () => {
      const sidebars = Array.from(
        document.querySelectorAll<HTMLElement>(selector),
      );
      const active = sidebars.find(
        (sidebar) => sidebar.getAttribute("aria-hidden") !== "true",
      );
      setWidth(active?.getBoundingClientRect().width ?? 0);
    };

    const resizeObserver = new ResizeObserver(updateWidth);
    const observeSidebars = () => {
      document.querySelectorAll<HTMLElement>(selector).forEach((sidebar) => {
        if (observed.has(sidebar)) return;
        observed.add(sidebar);
        resizeObserver.observe(sidebar);
      });
      updateWidth();
    };

    const mutationObserver = new MutationObserver(observeSidebars);
    mutationObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
      childList: true,
      subtree: true,
    });
    observeSidebars();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [side]);

  return width;
};
